import { z } from 'zod';
import { DifficultySchema } from '../enums/difficulty.js';
import { CategorySchema } from '../enums/category.js';
import { CognitiveLevelSchema } from './cognitive-level.js';
import { ChunkRefSchema } from './source-ref.js';
import { ItemTagsSchema, coerceItemTagsV3ToV4 } from './item-tags.js';
import { ConceptOmissionSchema } from './concept-omission.js';
// Session 19AE: full .describe() for LLM clarity.
// 19BH Day 2 Step 2.4: ItemTags base + omittedConcepts soft escape.
export const TrueFalseSchema = z.preprocess(coerceItemTagsV3ToV4, ItemTagsSchema.extend({
    id: z.string().regex(/^tf[a-z0-9_]+$/, 'tf id must start with "tf" (lowercase, snake_case)')
        .describe('Unique snake_case slug starting with `tf` (e.g. `tf_logic_03`).'),
    /** @deprecated v3 alias of caseIds[0]. Day 5 finalize sets for engine back-compat. */
    caseId: z.string().nullable().optional()
        .describe('@deprecated v3 alias of caseIds[0]. New code should read caseIds[].'),
    /** @deprecated v3 alias of topicIds[0]. */
    topicId: z.string().nullable().optional()
        .describe('@deprecated v3 alias of topicIds[0].'),
    subtopicId: z.string().nullable().optional()
        .describe('Subtopic id with topic prefix. null/omit if not applicable.'),
    section: z.string().nullable()
        .describe('Sub-section label for split cases.'),
    difficulty: DifficultySchema
        .describe('easy / medium / hard. T/F is harder when statement looks plausible but is wrong on a subtle point.'),
    cognitiveLevel: CognitiveLevelSchema.optional()
        .describe('Bloom 5-tier level.'),
    mockOnly: z.boolean()
        .describe('If true, only in mock exams; not in the daily T/F pool.'),
    category: CategorySchema
        .describe('framework / fact / causal / strategy / comparison / concept / policy.'),
    statement: z.string().min(20)
        .describe('A precise factual claim. ≥20 chars. Use a SINGLE clause — no "and"/"or" conjunctions that make T/F ambiguous. Crafted traps: swap a name, flip a sign, change a year by 1, swap cause/effect. Markdown OK.'),
    correct: z.boolean()
        .describe('true if the statement is correct as written; false if it has at least one factual error.'),
    explanation: z.string().min(60)
        .describe('Why the statement is correct/incorrect. ≥60 chars (start with "TRUE." / "FALSE." prefix + at least one substantive sentence). If false, point out exactly which word/clause is wrong and what the right value is. Markdown allowed. Constraint Session 19AO.'),
    /** @deprecated v3 alias of conceptIds[0]. */
    conceptTag: z.string().min(1).max(80).nullish()
        .describe('@deprecated v3 alias of conceptIds[0]. New code should read conceptIds[].'),
    sourceRef: ChunkRefSchema.nullish()
        .describe('19BG+2 Phase 5 (DEBT-AW-SOURCEREF): citation anchor. Snippet substring-verified against source. Optional for back-compat.'),
    omittedConcepts: z.array(ConceptOmissionSchema).nullish()
        .describe('K18 soft escape · concepts the LLM declared materially insufficient for this stage.'),
}).passthrough());
export const TrueFalseBankSchema = z.array(TrueFalseSchema);
//# sourceMappingURL=true-false.js.map